
import HeaderClasses from './AppHeader.module.css';
import { NavLink } from "react-router-dom";

const CTS_Header = () => {

	const phonestyle = {color: "#ea8b54", fontWeight: "bold", };

    return (
        <div className={HeaderClasses.appHeaderSp}>
			<span style={phonestyle}> 833-728-9800 </span>
        </div>
    );
};

export default CTS_Header;